import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import { hasUnlimitedVersion } from 'utils/hasUnlimitedVersion';
import Button from 'react-bootstrap/Button';

import MenuItem from './MenuItem';

type Props = {
  order: string;
  societyId: string;
  isActive: boolean;
};

const CommunicationsMenu: FC<Props> = ({ order, societyId, isActive }) => {
  const { t } = useTranslate();

  return (
    <>
      <Accordion.Toggle as={Button} variant="link" eventKey={order}>
        <li className={`nk-menu-item has-sub ${isActive ? 'active' : ''}`}>
          <a className="nk-menu-link nk-menu-toggle">
            <span className="nk-menu-icon">
              <em className="icon ni ni-mail" />
            </span>
            <span className="nk-menu-text">{t('Communications')}</span>
          </a>
        </li>
      </Accordion.Toggle>

      <Accordion.Collapse eventKey={order}>
        <ul className="nk-menu-sub">
          <MenuItem
            linkTo={`/comunicaciones/${societyId}`}
            text="Communications"
            disabled={!hasUnlimitedVersion()}
          />
        </ul>
      </Accordion.Collapse>
    </>
  );
};

export default CommunicationsMenu;
